// import axiosInstance from "./axiosInstance";
import axios from "axios";

const API_URL = process.env.REACT_APP_BASE_URL;

export const Profile = async(data)=>{
    // const config = {
    //     ...abortToken,
    //     timeout: 30000, // Set the timeout for this specific request
    //   };
    return  await axios.post(`${API_URL}/Profile`, data, { 
      headers: {           
          'Content-Type': 'multipart/form-data',        
      },       
  });  
  }